import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CrossIcon} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    '.MuiDialog-paper': {
      borderRadius: theme.spacing(2),
    },
  },
  //   '& .MuiDialogContent-root': {
  //     padding: theme.spacing(2),
  //   },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const Component = ({title, subtitle, invertedTitle, ...props}: PropTypes) => {
  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };
  const isLarge = useIsLargeDevice();
  return (
    <div>
      <BootstrapDialog {...props} fullScreen={props.fullScreen}>
        <Box
          sx={{
            py: subtitle ? 0 : 1,
            overflow: 'hidden',
            position: 'relative',
            pr: 6,
            height: '63px',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              zIndex: 1,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={handleClose}
              sx={{
                '&:hover': {
                  backgroundColor: 'white',
                },
              }}
            >
              <Box
                sx={{
                  cursor: 'pointer',
                  position: 'relative',
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#f2f5fa',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: 'white',
                    boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
                  },
                }}
              >
                <Image
                  width={14}
                  height={14}
                  src={CrossIcon}
                  alt={'white cross'}
                  // layout="fill"
                  // objectFit="cover"
                />
              </Box>
            </IconButton>
          </Box>
        </Box>
        <DialogContent sx={{padding: '0px 23px 23px'}}>
          {props.children}
        </DialogContent>
        {props.footer}
      </BootstrapDialog>
    </div>
  );
};

export default Component;
